import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, first, map, switchMap, tap } from 'rxjs';
import { userProfile } from '../../user/user.selectors';
import { UserProxyService } from 'src/app/infrastructure/lobby-proxy/lobby-proxy-user/user-proxy.service';
import { UserAction } from '../../user/action-types';
import { userPropertiesContainerDtoToUserProperty } from '../../mappings/user-model-dto/user-property-dto.mapping';
import { BaseFilterOptions } from '../../ui-kit/dashboard/dashboard-filter-button/base-filter-options.model';

export interface FilterState {
  option: any,
  form: any
}

export class BoardFilterService<TOptions extends BaseFilterOptions> {

  protected appStore = inject(Store)
  private userProxyService = inject(UserProxyService)

  constructor(private readonly filterName: string, private readonly optionFactory: (obj: any) => TOptions) { }

  getFilterState$(): Observable<FilterState | null> {

    return this.userProxyService.getCurrentUserProperties$().pipe(
      map(dto => dto.data),
      map(data => userPropertiesContainerDtoToUserProperty(data).find(p => p.name == this.getPropertyKeyName(this.filterName))),
      map(property => {
        if (!property?.value) return null

        const propertyValue = JSON.parse(property!.value as string) as FilterState
        return {
          option: this.optionFactory(propertyValue.option),
          form: propertyValue.form
        }
      })
    )

  }

  saveFilterState$(state: FilterState): Observable<void> {

    const propertyName = this.getPropertyKeyName(this.filterName)
    const value = JSON.stringify(state)

    return this.appStore.pipe(
      userProfile,
      first(),
      switchMap((user) => !user.properties.find(p => p.name == propertyName) ?
        this.userProxyService.setNewUserProperty$(user.id, user.version, propertyName, value) :
        this.userProxyService.setUserProperty$(user.id, user.version, propertyName, value)
      ),
      tap(() => this.appStore.dispatch(UserAction.loadUser())),
      map(() => void 0)
    )
  }

  private getPropertyKeyName(name: string) {
    return 'Webapp_' + name
  }

}
